import { useEffect } from 'react'

const SITE = 'calendarfeedback.com'

/** Sets document.title for the current route. Pass nothing to restore the
 *  landing page title baked into index.html. */
export function useTitle(page?: string) {
  useEffect(() => {
    const prev = document.title
    if (page) document.title = `${page} – ${SITE}`
    return () => { document.title = prev }
  }, [page])
}
